import { SITE } from '../components/SEO';

const ADDRESS = {
  '@type': 'PostalAddress',
  streetAddress: '2nd Floor, Darshan Orchid Complex, MSK Mill Road',
  addressLocality: 'Kalaburagi',
  addressRegion: 'Karnataka',
  postalCode: '585103',
  addressCountry: 'IN',
};

export function buildCourseSchema(course) {
  const canonicalUrl = SITE.url + '/courses/' + course.slug;
  return {
    '@context': 'https://schema.org',
    '@type': 'Course',
    name: course.name + ' Course',
    description: course.metaDescription,
    provider: {
      '@type': 'EducationalOrganization',
      name: 'Genius Academy',
      sameAs: SITE.url,
      address: ADDRESS,
    },
    hasCourseInstance: {
      '@type': 'CourseInstance',
      courseMode: 'onsite',
      location: {
        '@type': 'Place',
        name: 'Genius Academy Computer Lab',
        address: ADDRESS,
      },
    },
    offers: {
      '@type': 'Offer',
      category: 'Onsite Classroom Training',
      priceCurrency: 'INR',
      availability: 'https://schema.org/InStock',
      url: canonicalUrl,
    },
  };
}

export function buildCourseFaqSchema(course) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: course.faqs.map(function (f) {
      return {
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      };
    }),
  };
}
